

export default [
  {
    title: 'ข้อมูลสินค้า',
    icon: 'ShoppingCartIcon',
    children: [
      {
        title: 'รายการข้อมูล',
        route: 'product-list',
      },
      {
        title: 'ดูข้อมูล',
        route: { name: 'product-view-new', params: { id: 21 } },
        disabled: true,
      },
      // {
      //   title: 'แก้ไขข้อมูล',
      //   route: { name: 'product-edit', params: { id: 21 } },
      // },
      // {
      //   title: 'เพิ่มข้อมูล',
      //   route: { name: 'product-add', params: { id: 21 } },
      // },
    ],
  },
]
